export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Partial<Record<string, string | number | boolean>> = {},
  children: Array<Node | string> = []
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (v === undefined || v === false || v === null) continue;
    if (k === 'class') node.className = String(v);
    else if (k === 'html') node.innerHTML = String(v);
    else if (k.startsWith('on') && typeof v === 'string') node.setAttribute(k, v);
    else node.setAttribute(k, String(v));
  }
  for (const c of children) {
    node.append(typeof c === 'string' ? document.createTextNode(c) : c);
  }
  return node;
}

export function getRoot(): HTMLElement {
  const root = document.getElementById('ui-root');
  if (!root) throw new Error('ui-root not found');
  return root;
}

export function clearRoot(): void {
  const root = getRoot();
  root.innerHTML = '';
}

export function mount(node: HTMLElement): void {
  const root = getRoot();
  root.append(node);
}
